import React, { useState } from 'react';
import './PreviewPage.css';
import RemixPage from './RemixPage';
import CommentsPage from './CommentsPage';
import LoadingView from '../components/LoadingView'; // 引入进度条组件

function PreviewPage({ onBack }) {
  const [showRemix, setShowRemix] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false); // 发布状态

  // 1. 如果处于改编模式
  if (showRemix) {
    return <RemixPage onBack={() => setShowRemix(false)} />;
  }

  // 2. 如果处于发布中 (显示LoadingView)
  if (isPublishing) {
    return (
      <LoadingView 
        title="正在发布作品..." 
        subtitle="正在上传音频并同步至社区"
        duration={1500} // 发布快一点
        onFinish={() => {
          setIsPublishing(false);
          setShowComments(true); // 发布完成后直接进入评论区
        }}
      />
    );
  }

  // 3. 如果处于评论模式
  if (showComments) {
    return <CommentsPage onBack={() => setShowComments(false)} />;
  }

  // 处理发布点击
  const handlePublish = () => {
    setIsPublishing(true);
  };

  // 4. 默认显示试听页面
  return (
    <div className="preview-page">
      <div className="preview-header">
        <button className="back-button" onClick={onBack}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h2>试听</h2>
        <div style={{ width: 36 }}></div>
      </div>

      <div className="preview-content">
        <div className="preview-cover">
          <i className="fas fa-music preview-music-icon"></i>
        </div>

        <h3 className="preview-title">生成的音乐作品</h3>
        <p className="preview-subtitle">AI 创作 · 刚刚</p>

        <div className="preview-controls">
          <button className="control-button">
            <i className="fas fa-backward"></i>
          </button>
          <button className="control-button play-button">
            <i className="fas fa-play"></i>
          </button>
          <button className="control-button">
            <i className="fas fa-forward"></i>
          </button>
        </div>

        <div className="preview-progress">
          <span className="time-label">0:00</span>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: '30%' }}></div>
          </div>
          <span className="time-label">3:45</span>
        </div>

        <div className="preview-actions">
          <button className="action-button" onClick={() => setShowComments(true)}>
            <i className="fas fa-comment-dots"></i>
            <span>评论</span>
          </button>
          
          <button className="action-button magic-wand-btn" onClick={() => setShowRemix(true)}>
            <i className="fas fa-wand-magic-sparkles"></i>
            <span>音乐魔法棒</span>
          </button>
          
          {/* 修改后的发布按钮 */}
          <button className="action-button" onClick={handlePublish}>
            <i className="fas fa-paper-plane"></i>
            <span>发布</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default PreviewPage;